/**
 * Preset groups — shared by AddGifteeWizard interests step and profile "More" sheet
 * (node 501:16600). Rewritten to the 9 Amazon-shoppable categories: "Education" and
 * "Travel" were services rather than shoppable goods and didn't map to the Amazon
 * PA-API, so they were replaced with "Books & Learning" and "Outdoors & Adventure".
 */
export const INTEREST_GROUPS = [
  {
    id: "food-drink",
    label: "Food & Drink",
    chips: [
      "Coffee",
      "Tea",
      "Wine",
      "Cocktails",
      "Snacks",
      "Baking",
      "BBQ",
      "Chocolate",
    ],
  },
  {
    id: "fitness-wellness",
    label: "Fitness & Wellness",
    chips: ["Running", "Biking", "Yoga", "Strength", "Recovery"],
  },
  {
    id: "tech-gadgets",
    label: "Tech & Gadgets",
    chips: [
      "Headphones",
      "Audio",
      "Smart Home",
      "Photography",
      "Desk Setup",
      "Gaming",
      "EDC",
    ],
  },
  {
    id: "home-cozy",
    label: "Home & Cozy",
    chips: [
      "Candles",
      "Blankets",
      "Mugs",
      "Plants",
      "Organization",
      "Kitchen Gadgets",
    ],
  },
  {
    id: "outdoors-adventure",
    label: "Outdoors & Adventure",
    chips: ["Camping", "Hiking", "Fishing", "Gardening", "Travel Gear", "Outdoors"],
  },
  {
    id: "books-learning",
    label: "Books & Learning",
    chips: [
      "Fiction",
      "Nonfiction",
      "Puzzles",
      "Journaling",
      "Audiobooks",
      "Language Learning",
    ],
  },
  {
    id: "arts-crafts",
    label: "Arts & Crafts",
    chips: ["Drawing", "Knitting", "DIY", "Stationery", "Painting"],
  },
  {
    id: "fashion-beauty",
    label: "Fashion & Beauty",
    chips: ["Jewelry", "Fragrance", "Accessories", "Skincare", "Loungewear"],
  },
  {
    id: "pets-animals",
    label: "Pets & Animals",
    chips: ["Dogs", "Cats", "Small Pets", "Pet Parent Gear"],
  },
];

export const PRESET_INTEREST_LABELS = new Set(
  INTEREST_GROUPS.flatMap((g) => g.chips),
);
